var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoteOnAClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 380.722 380.721",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M115.455,113.184c7.674,0,13.896,6.222,13.896,13.896c0,7.674-6.222,13.896-13.896,13.896 c-7.68,0-13.901-6.222-13.901-13.896C101.554,119.405,107.775,113.184,115.455,113.184z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.529,
    y: 115.298,
    width: 135.259,
    height: 23.545
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.455,168.123c7.674,0,13.896,6.222,13.896,13.896c0,7.68-6.222,13.896-13.896,13.896 c-7.68,0-13.901-6.216-13.901-13.896C101.554,174.344,107.775,168.123,115.455,168.123z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.529,
    y: 170.254,
    width: 135.259,
    height: 23.545
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.455,228.969c7.674,0,13.896,6.217,13.896,13.896s-6.222,13.896-13.896,13.896c-7.68,0-13.901-6.216-13.901-13.896 S107.775,228.969,115.455,228.969z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.529,
    y: 231.084,
    width: 135.259,
    height: 23.551
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.455,283.915c7.674,0,13.896,6.215,13.896,13.896c0,7.669-6.222,13.896-13.896,13.896 c-7.68,0-13.901-6.227-13.901-13.896C101.554,290.129,107.775,283.915,115.455,283.915z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.529,
    y: 286.041,
    width: 135.259,
    height: 23.551
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.325,30.424h-59.546V11.781c0,0-44.488-11.781-74.156-11.781c-29.674,0-74.168,11.781-74.168,11.781v18.643H57.391 c-8.661,0-15.69,7.018-15.69,15.691v318.921c0,8.656,7.029,15.686,15.69,15.686h265.935c8.679,0,15.696-7.029,15.696-15.686 V46.115C339.021,37.441,331.98,30.424,323.325,30.424z M190.361,13.588c7.993,0,14.465,6.471,14.465,14.465 c0,7.982-6.472,14.459-14.465,14.459c-7.994,0-14.472-6.477-14.472-14.459C175.89,20.06,182.367,13.588,190.361,13.588z  M307.628,349.327H73.111V61.817h42.355v10.793h148.324V61.817h43.837V349.327L307.628,349.327z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteOnAClipboard);
export default __webpack_public_path__ + "static/media/note-on-a-clipboard.9667dc27fec40219daf60c2a3b2168a6.svg";
export { ForwardRef as ReactComponent };